import { render, staticRenderFns } from "./lgmain.vue?vue&type=template&id=74889578&"
import script from "./lgmain.vue?vue&type=script&lang=js&"
export * from "./lgmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74889578', component.options)
    } else {
      api.reload('74889578', component.options)
    }
    module.hot.accept("./lgmain.vue?vue&type=template&id=74889578&", function () {
      api.rerender('74889578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/lgmain.vue"
export default component.exports